// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PShopOutlinedSvg from "@fishx/icons-svg/es/asn/PShopOutlined";
import FishxIcon from '../components/FishxIcon';

var PShopOutlined = function PShopOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PShopOutlinedSvg
  }));
};

PShopOutlined.displayName = 'PShopOutlined';
export default React.forwardRef(PShopOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PShopOutlined.js
// module id = 3625
// module chunks = 0